/**
 * @prettier
 */
import { ToggleActivate } from "./Toggle";

export default ToggleActivate;
